import Layout from "../../components/feature/Layout";
import { useState } from "react";

export default function Settings() {
  const [activeTab, setActiveTab] = useState("general");

  const tabs = [
    { id: "general", name: "General", icon: "ri-settings-3-line" },
    { id: "company", name: "Empresa", icon: "ri-building-line" },
    { id: "notifications", name: "Notificaciones", icon: "ri-notification-line" },
    { id: "security", name: "Seguridad", icon: "ri-shield-check-line" },
    { id: "integrations", name: "Integraciones", icon: "ri-plug-line" },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-[#0A2A43]">Configuración</h1>
          <p className="text-sm text-gray-500 mt-1">Configuración general del sistema</p>
        </div>

        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
          <div className="border-b border-gray-200">
            <div className="flex gap-1 p-2 overflow-x-auto">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-4 py-2 rounded-md whitespace-nowrap flex items-center gap-2 transition-all ${
                    activeTab === tab.id
                      ? "bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
                >
                  <i className={tab.icon}></i>
                  {tab.name}
                </button>
              ))}
            </div>
          </div>

          <div className="p-6">
            {activeTab === "general" && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#0A2A43] mb-4">Configuración General</h3>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Idioma del Sistema</label>
                      <select className="w-full md:w-1/2 px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent">
                        <option>Español</option>
                        <option>English</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Zona Horaria</label>
                      <select className="w-full md:w-1/2 px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent">
                        <option>América/México (GMT-6)</option>
                        <option>América/Los_Angeles (GMT-8)</option>
                        <option>América/New_York (GMT-5)</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Formato de Fecha</label>
                      <select className="w-full md:w-1/2 px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent">
                        <option>DD/MM/YYYY</option>
                        <option>MM/DD/YYYY</option>
                        <option>YYYY-MM-DD</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "company" && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#0A2A43] mb-4">Información de la Empresa</h3>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nombre de la Empresa</label>
                      <input
                        type="text"
                        defaultValue="COMINTER"
                        className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">RFC</label>
                      <input
                        type="text"
                        defaultValue="COM850623AB1"
                        className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Dirección</label>
                      <textarea
                        rows={3}
                        defaultValue="Av. Insurgentes Sur 1234, Col. Del Valle, CDMX"
                        className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "notifications" && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#0A2A43] mb-4">Preferencias de Notificaciones</h3>
                  <div className="space-y-4">
                    {[
                      { label: "Alertas de operaciones en riesgo", checked: true },
                      { label: "Notificaciones de nuevas operaciones", checked: true },
                      { label: "Recordatorios de documentos pendientes", checked: true },
                      { label: "Actualizaciones del sistema", checked: false },
                      { label: "Reportes automáticos semanales", checked: true },
                    ].map((item, index) => (
                      <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                        <span className="text-sm text-gray-700">{item.label}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" defaultChecked={item.checked} className="sr-only peer" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#2F80ED]/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#2F80ED]"></div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "security" && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#0A2A43] mb-4">Seguridad</h3>
                  <div className="space-y-4">
                    <div className="p-4 bg-[#EAF2F8] rounded-lg">
                      <div className="flex items-start gap-3">
                        <i className="ri-shield-check-line text-2xl text-[#10B981]"></i>
                        <div>
                          <p className="text-sm font-semibold text-[#0A2A43]">Autenticación de dos factores</p>
                          <p className="text-xs text-gray-600 mt-1">Activada</p>
                        </div>
                      </div>
                    </div>
                    <button className="w-full md:w-auto px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:opacity-90 transition-opacity whitespace-nowrap">
                      Cambiar Contraseña
                    </button>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "integrations" && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#0A2A43] mb-4">Integraciones Disponibles</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[
                      { name: "SAT - Facturación Electrónica", status: "Conectado", icon: "ri-file-text-line" },
                      { name: "Bancos - Conciliación", status: "Conectado", icon: "ri-bank-line" },
                      { name: "WhatsApp Business", status: "Disponible", icon: "ri-whatsapp-line" },
                      { name: "API Aduanas", status: "Conectado", icon: "ri-ship-line" },
                    ].map((integration, index) => (
                      <div key={index} className="p-4 border border-gray-200 rounded-lg hover:border-[#2F80ED] transition-colors">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                              <i className={`${integration.icon} text-xl text-[#2F80ED]`}></i>
                            </div>
                            <div>
                              <p className="text-sm font-semibold text-[#0A2A43]">{integration.name}</p>
                              <p className={`text-xs ${integration.status === "Conectado" ? "text-[#10B981]" : "text-gray-500"}`}>
                                {integration.status}
                              </p>
                            </div>
                          </div>
                          <button className="px-3 py-1 text-xs border border-[#2F80ED] text-[#2F80ED] rounded-md hover:bg-[#EAF2F8] transition-colors whitespace-nowrap">
                            {integration.status === "Conectado" ? "Configurar" : "Conectar"}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="border-t border-gray-200 p-6 bg-gray-50">
            <div className="flex justify-end gap-3">
              <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition-colors whitespace-nowrap">
                Cancelar
              </button>
              <button className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:opacity-90 transition-opacity whitespace-nowrap">
                Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
